import { FormControl, FormGroup, Validators } from '@angular/forms';

import { requiredFieldValidator } from '../validations';

export const clientMetricsFilterForm = (): FormGroup => {
  return new FormGroup({
    client: new FormControl('', [Validators.required, requiredFieldValidator]),
    year: new FormControl('', Validators.required),
    startDate: new FormControl(),
    endDate: new FormControl(),
    quarter: new FormControl('All', Validators.required),
    subscriptionGroup: new FormControl([], Validators.required),
    partnerInfo: new FormControl('PSCU', Validators.required),
    statuses: new FormControl([], Validators.required),
    calculateROI: new FormControl(false),
  });
};
